
let inputBannerSearch, autocompleteResults;
document.addEventListener('DOMContentLoaded', initBannerWithSearch);

function initBannerWithSearch() {
	inputBannerSearch = document.getElementById("autocomplete-input");
	autocompleteResults = document.getElementById("autocomplete-results");
	const autocompleteContainer = document.getElementById("autocomplete-container");
	const searchIcon = document.querySelector('#autocomplete-container .input-icon');

	if (!inputBannerSearch || !autocompleteResults) {
		console.error('Required elements not found');
		return;
	}

	inputBannerSearch.addEventListener("input", handleInput);
	inputBannerSearch.addEventListener('keydown', handleKeyPress);
	searchIcon.addEventListener('click', handleSearchIconClick);
	document.addEventListener('click', handleDocumentClick);

	function handleInput() {
		const searchTerm = inputBannerSearch.value.trim();
		if (!searchTerm) {
			return clearResults();
		}
		fetchAutocompleteResults(searchTerm);
	}

	function handleKeyPress(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();

			const searchQuery = inputBannerSearch.value.trim();
			navigateToSearch(searchQuery);
		}
	}
	function handleSearchIconClick(event) {
		event.preventDefault();
		const searchQuery = inputBannerSearch.value.trim();
		navigateToSearch(searchQuery);
	}

	function navigateToSearch(searchQuery) {
		const searchUrl = searchQuery ?
			`/search?q=${encodeURIComponent(searchQuery)}` :
			'/search';

		clearResults();
		window.location.href = searchUrl;
	}

	function handleDocumentClick(event) {
		const target = event.target;

		const clickedInsideSearch =
			(autocompleteContainer && autocompleteContainer.contains(target)) ||
			(autocompleteResults && autocompleteResults.contains(target));

		if (clickedInsideSearch) {
			return;
		}

		clearResults();
	}

	async function fetchAutocompleteResults(searchTerm) {
		try {
			const response = await fetch('/tools/proxy/api/books/search', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					searchTerm: searchTerm,
					page: 1
				}),
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const result = await response.json();
			const data = result.data || [];

			if (!data.length) {
				clearResults();
				return;
			}

			renderResults(data);

		} catch (error) {
			console.error('Autocomplete fetch error:', error);
			clearResults();
		}
	}

	function clearResults() {
		autocompleteResults.innerHTML = "";
		autocompleteResults.style.display = "none";
	};

	function renderResults(data) {
		autocompleteResults.innerHTML = "";
		const maxResults = data.slice(0, 5);
		maxResults.forEach((item) => {
			const li = document.createElement("li");
			const link = document.createElement("a");
			link.href = `/products/${item.handle}`;
			link.textContent = `${item.title} ${item.author ? '| ' + item.author : ''}`;
			li.appendChild(link);
			autocompleteResults.appendChild(li);
		});
		autocompleteResults.style.display = "block";
	}
}

